module.exports = __webpack_public_path__ + "media/homepage/josh-w-1b24d1b3.webp";